var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { BaseView } from '../../components/BaseView';
import { VerticalResourceIterator } from '../common/VerticalResourceIterator';
import { useCellSync } from '../../hooks/main';
import { DAYS_IN_WEEK_COUNT } from '../../constants/main';
import { MS_PER_DAY, getDate, addDays, firstDayInWeek, ZonedDate } from '@progress/kendo-date-math';
import { provideIntlService, provideLocalizationService } from '@progress/kendo-vue-intl';
import { toRanges } from '../../services/rangeService';
import { toOccurrences } from '../../services/occurrenceService';
import { toItems } from '../../services/itemsService';
import { toUTCDateTime, mapItemsToSlots, mapSlotsToItems } from '../../utils/main';
import { toSlots } from '../../services/main';
import { AgendaViewHead } from './AgendaViewHead';
import { AgendaViewBody } from './AgendaViewBody';
import { SchedulerEditTask } from '../../tasks/SchedulerEditTask';
import { SchedulerEditSlot } from '../../slots/SchedulerEditSlot';
/**
 * @hidden
 */
var AgendaViewVue2 = {
  name: 'KendoAgendaView',
  props: {
    name: {
      type: String,
      default: 'agenda'
    },
    // title: (localization: LocalizationService): string =>
    // localization.toLanguageString(agendaViewTitle, messages[agendaViewTitle]),
    dateRange: {
      type: [Function, Object],
      default: function _default() {
        return agendaViewDateRange;
      }
    },
    selectedDateFormat: {
      type: String,
      default: '{0:D} - {1:D}'
    },
    selectedShortDateFormat: {
      type: String,
      default: '{0:d} - {1:d}'
    },
    slotDuration: {
      type: Number,
      default: 60 * 24
    },
    slotDivisions: {
      type: Number,
      default: 1
    },
    step: {
      type: Number,
      default: DAYS_IN_WEEK_COUNT
    },
    numberOfDays: {
      type: Number,
      default: DAYS_IN_WEEK_COUNT
    },
    task: [String, Function, Object],
    editable: {
      type: [Boolean, Object],
      default: false
    }
  },
  inject: {
    ks: {
      default: null
    },
    kendoLocalizationService: {
      default: null
    },
    kendoIntlService: {
      default: null
    }
  },
  created: function created() {
    this.intl = provideIntlService(this);
  },
  mounted: function mounted() {
    useCellSync({
      element: this.$el,
      selector: '.k-scheduler-datecolumn',
      explicitDepth: false
    });
    useCellSync({
      element: this.$el,
      selector: '.k-scheduler-timecolumn',
      explicitDepth: false
    });
  },
  updated: function updated() {
    useCellSync({
      element: this.$el,
      selector: '.k-scheduler-datecolumn',
      explicitDepth: false
    });
    useCellSync({
      element: this.$el,
      selector: '.k-scheduler-timecolumn',
      explicitDepth: false
    });
  },
  computed: {
    ranges: function ranges() {
      return toRanges(this.ks.dateRange, {
        step: MS_PER_DAY,
        timezone: this.ks.timezone
      });
    },
    agendaSlots: function agendaSlots() {
      return toSlots(this.ks.dateRange, {
        step: MS_PER_DAY
      }, {
        groups: this.ks.groups,
        ranges: this.ranges
      });
    },
    occurrences: function occurrences() {
      return toOccurrences(this.ks.dataItems, {
        dateRange: this.ks.dateRange,
        fields: this.ks.fields,
        timezone: this.ks.timezone
      });
    },
    items: function items() {
      var items = toItems(this.occurrences, {
        timezone: this.ks.timezone
      }, {
        groups: this.ks.groups,
        ranges: this.ranges
      });
      mapItemsToSlots(items, this.agendaSlots, true);
      mapSlotsToItems(items, this.agendaSlots, true);
      return items;
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this = this;
    var h = gh || createElement;
    var EditTask = this.$props.editTask || SchedulerEditTask;
    var EditSlot = this.$props.editSlot || SchedulerEditSlot;
    var intl = provideIntlService(this);
    var localization = provideLocalizationService(this);
    var agendaSlots = this.agendaSlots;
    return (
      // @ts-ignore  function children
      h(BaseView, {
        id: this.$props.id,
        attrs: this.v3 ? undefined : {
          id: this.$props.id,
          viewProps: __assign({}, this.$props),
          baseSlots: this.items,
          ranges: this.ranges,
          isAgendaView: true
        },
        "class": 'k-scheduler-agendaview',
        viewProps: __assign({}, this.$props),
        baseSlots: this.items,
        ranges: this.ranges,
        isAgendaView: true
      }, this.v3 ? function () {
        return [h("div", {
          "class": "k-scheduler-head"
        }, [
        // @ts-ignore  function children
        h(VerticalResourceIterator, {
          resources: _this.ks.props.resources,
          attrs: _this.v3 ? undefined : {
            resources: _this.ks.props.resources,
            group: _this.ks.props.group
          },
          group: _this.ks.props.group
        }, _this.v3 ? function () {
          return [
          // @ts-ignore
          h(AgendaViewHead)];
        } : [h(AgendaViewHead)])]),
        // @ts-ignore  function children
        h(VerticalResourceIterator, {
          resources: _this.ks.props.resources,
          attrs: _this.v3 ? undefined : {
            resources: _this.ks.props.resources,
            group: _this.ks.props.group,
            nested: true
          },
          group: _this.ks.props.group,
          nested: true
        }, _this.v3 ? function () {
          return [h(AgendaViewBody, {
            items: _this.items,
            attrs: _this.v3 ? undefined : {
              items: _this.items,
              agendaSlots: agendaSlots,
              task: _this.$props.task,
              editable: _this.$props.editable
            },
            agendaSlots: agendaSlots,
            task: _this.$props.task,
            editable: _this.$props.editable,
            onDataaction: _this.handleDataAction,
            on: _this.v3 ? undefined : {
              "dataaction": _this.handleDataAction
            }
          })];
        } : [h(AgendaViewBody, {
          items: _this.items,
          attrs: _this.v3 ? undefined : {
            items: _this.items,
            agendaSlots: agendaSlots,
            task: _this.$props.task,
            editable: _this.$props.editable
          },
          agendaSlots: agendaSlots,
          task: _this.$props.task,
          editable: _this.$props.editable,
          onDataaction: _this.handleDataAction,
          on: _this.v3 ? undefined : {
            "dataaction": _this.handleDataAction
          }
        })])];
      } : [h("div", {
        "class": "k-scheduler-head"
      }, [h(VerticalResourceIterator, {
        resources: _this.ks.props.resources,
        attrs: _this.v3 ? undefined : {
          resources: _this.ks.props.resources,
          group: _this.ks.props.group
        },
        group: _this.ks.props.group
      }, _this.v3 ? function () {
        return [h(AgendaViewHead)];
      } : [h(AgendaViewHead)])]), h(VerticalResourceIterator, {
        resources: _this.ks.props.resources,
        attrs: _this.v3 ? undefined : {
          resources: _this.ks.props.resources,
          group: _this.ks.props.group,
          nested: true
        },
        group: _this.ks.props.group,
        nested: true
      }, _this.v3 ? function () {
        return [h(AgendaViewBody, {
          items: _this.items,
          attrs: _this.v3 ? undefined : {
            items: _this.items,
            agendaSlots: agendaSlots,
            task: _this.$props.task,
            editable: _this.$props.editable
          },
          agendaSlots: agendaSlots,
          task: _this.$props.task,
          editable: _this.$props.editable,
          onDataaction: _this.handleDataAction,
          on: _this.v3 ? undefined : {
            "dataaction": _this.handleDataAction
          }
        })];
      } : [h(AgendaViewBody, {
        items: _this.items,
        attrs: _this.v3 ? undefined : {
          items: _this.items,
          agendaSlots: agendaSlots,
          task: _this.$props.task,
          editable: _this.$props.editable
        },
        agendaSlots: agendaSlots,
        task: _this.$props.task,
        editable: _this.$props.editable,
        onDataaction: _this.handleDataAction,
        on: _this.v3 ? undefined : {
          "dataaction": _this.handleDataAction
        }
      })])])
    );
  },
  methods: {
    handleDataAction: function handleDataAction(action) {
      this.$emit('dataaction', action);
    }
  }
};
var GET_START_DATE = function GET_START_DATE(date) {
  return getDate(date);
};
var GET_END_DATE = function GET_END_DATE(start, numberOfDays) {
  return getDate(addDays(start, numberOfDays || 1));
};
var agendaViewDateRange = function agendaViewDateRange(_a) {
  var intl = _a.intl,
    date = _a.date,
    _b = _a.numberOfDays,
    numberOfDays = _b === void 0 ? 1 : _b,
    timezone = _a.timezone;
  var normalized = ZonedDate.fromLocalDate(date, timezone);
  var firstDate = numberOfDays === DAYS_IN_WEEK_COUNT ? GET_START_DATE(firstDayInWeek(normalized, intl.firstDay())) : GET_START_DATE(normalized);
  var lastDate = GET_END_DATE(firstDate, numberOfDays);
  var zonedStart = ZonedDate.fromUTCDate(toUTCDateTime(firstDate), timezone);
  var zonedEnd = ZonedDate.fromUTCDate(toUTCDateTime(lastDate), timezone);
  var start = new Date(zonedStart.getTime());
  var end = new Date(zonedEnd.getTime());
  return {
    start: start,
    end: end,
    zonedStart: zonedStart,
    zonedEnd: zonedEnd
  };
};
/**
 * @hidden
 */
var AgendaView = AgendaViewVue2;
export { AgendaView, AgendaViewVue2 };